document.querySelectorAll('.open-modal-btn').forEach(openBtn => {
  openBtn.addEventListener('click', function () {
    const modal = document.querySelector('.custom-message-modal-overlay');
    if (!modal) return;

    modal.classList.add('d-flex');

    const closeModal = () => { 
      modal.classList.remove('d-flex');
      if( document.querySelector('.custom-message-modal-btn.changed')) {
          document.querySelector('.custom-message-modal-btn.changed').remove();
      }
      if( document.querySelector('.custom-message-modal-btn.updated')) {
          document.querySelector('.custom-message-modal-btn.updated').remove();
      }
      if( document.querySelector('.custom-message-modal-btn.removed')) {
          document.querySelector('.custom-message-modal-btn.removed').remove();
      }
      if( document.querySelector('.custom-message-modal-btn.account-detail')) {
          document.querySelector('.custom-message-modal-btn.account-detail').remove();
      }
      if( document.querySelector('.custom-message-modal-btn.job-detail')) {
          document.querySelector('.custom-message-modal-btn.job-detail').remove();
      }
    };

    // Avoid attaching multiple event listeners
    if( document.querySelector('.custom-message-modal-close') ) {
      modal.querySelector('.custom-message-modal-close').onclick = closeModal; 
    }
    if( document.querySelector('.custom-message-modal-btn.cancel') ) {
      modal.querySelector('.custom-message-modal-btn.cancel').onclick = closeModal;
    }

    // Outside click
    window.addEventListener('click', function outsideClick(e) {
      if (e.target === modal) {
        if( ! modal.classList.contains('processing')) {
          closeModal();
          window.removeEventListener('click', outsideClick);
        }
      }
    });
  });
});